import { CustomFieldValue } from '../../../../../types/custom_field';
import { ProductMasterData } from '../../../../../types/product_master_data/productMasterData';
import { PdfFieldEntity } from '../PdfDataKey';
import { PdfEntityDataResolver } from '../PdfEntityDataResolver';

export enum PdfProductMasterDataProperty {
  productName = 'productName',
  productNumber = 'productNumber',
  globalTradeItemNumber = 'globalTradeItemNumber',
}

export class PdfProductMasterDataDataResolver extends PdfEntityDataResolver<
  ProductMasterData,
  PdfProductMasterDataProperty
> {
  properties = Object.values(PdfProductMasterDataProperty);
  entityType = PdfFieldEntity.productMasterData;

  getCustomFieldByEntity(entity: ProductMasterData, id: string): CustomFieldValue | undefined {
    return entity.customFields.get(id);
  }

  getLabelByProperty(property: PdfProductMasterDataProperty): string {
    switch (property) {
      case PdfProductMasterDataProperty.productName:
        return 'Product Name';
      case PdfProductMasterDataProperty.productNumber:
        return 'Product Number';
      case PdfProductMasterDataProperty.globalTradeItemNumber:
        return 'Global Trade Item Number';
    }
  }

  getValueByProperty(property: PdfProductMasterDataProperty, entity: ProductMasterData): string {
    switch (property) {
      case PdfProductMasterDataProperty.productName:
        return entity.productName;
      case PdfProductMasterDataProperty.productNumber:
        return entity.productNumber;
      case PdfProductMasterDataProperty.globalTradeItemNumber:
        return entity.globalTradeItemNumber || '';
    }
  }
}
